import React, { createContext, useCallback } from 'react';
import CreatePasswordFormProvider from 'src/Booking/components/CreatePasswordForm/CreatePasswordFormProvider';
import CreateUsernameFormProvider from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormProvider';
import { basePath, BookingPathKeys, paths } from 'src/Booking/paths';
import PatientInfoFormProvider from '../PatientInfoForm/PatientInfoFormProvider';
import SignUpFormProvider from '../SignUpForm/SignUpFormProvider';

export const CreateAccountNavigationContext = createContext();

const PreviousPathLookup = {
    [paths[BookingPathKeys.createUsernamePath]]:
        paths[BookingPathKeys.patientInfoPath],
    [paths[BookingPathKeys.createPasswordPath]]:
        paths[BookingPathKeys.createUsernamePath],
    [paths[BookingPathKeys.signUpPath]]: paths[BookingPathKeys.patientInfoPath],
};

/**
 * @param {{
 *     currentPage: string,
 *     goBackToPage: function(input: string): void,
 *     onSubmitPatientInfoSuccess: function(): void,
 *     onSubmitSignUpSuccess: function(): void,
 * }} props
 * @returns {JSX.Element}
 */
const CreateAccountContainer = (props) => {
    const goBackToPreviousPage = useCallback(() => {
        const currentPath = `${basePath}/${props.currentPage}`;
        props.goBackToPage(PreviousPathLookup[currentPath]);
    }, [props]);

    const goBackToPatientInfo = useCallback(() => {
        props.goBackToPage(paths.patientInfoPath);
    }, [props]);

    return (
        <CreateAccountNavigationContext.Provider
            value={{ goBackToPatientInfo, goBackToPreviousPage }}
        >
            <PatientInfoFormProvider
                onSubmitSuccess={props.onSubmitPatientInfoSuccess}
            >
                <SignUpFormProvider
                    goBackToPatientInfo={goBackToPatientInfo}
                    onSubmitSuccess={props.onSubmitSignUpSuccess}
                >
                    <CreateUsernameFormProvider
                        goBackToPatientInfo={goBackToPatientInfo}
                        onSubmitSuccess={props.onSubmitCreateUsernameSuccess}
                    >
                        <CreatePasswordFormProvider
                            goBackToPatientInfo={goBackToPatientInfo}
                            goBackToPreviousPage={goBackToPreviousPage}
                            onSubmitSuccess={props.onSubmitSignUpSuccess}
                        >
                            {props.children}
                        </CreatePasswordFormProvider>
                    </CreateUsernameFormProvider>
                </SignUpFormProvider>
            </PatientInfoFormProvider>
        </CreateAccountNavigationContext.Provider>
    );
};

export default CreateAccountContainer;
